var minusImgCanvas = function () {
    var c = document.getElementById("minusIcon");
    c.height = 12;
    c.width = 18;
    var cx = c.getContext("2d");
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(0, 0, 1, 1);
    cx.fillRect(1, 0, 1, 1);
    cx.fillRect(2, 0, 1, 1);
    cx.fillRect(3, 0, 1, 1);
    cx.fillRect(4, 0, 1, 1);
    cx.fillRect(5, 0, 1, 1);
    cx.fillRect(6, 0, 1, 1);
    cx.fillRect(7, 0, 1, 1);
    cx.fillRect(8, 0, 1, 1);
    cx.fillRect(9, 0, 1, 1);
    cx.fillRect(10, 0, 1, 1);
    cx.fillRect(11, 0, 1, 1);
    cx.fillStyle = "rgba(254,254,254,1)";
    cx.fillRect(12, 0, 1, 1);
    cx.fillRect(13, 0, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(14, 0, 1, 1);
    cx.fillRect(15, 0, 1, 1);
    cx.fillStyle = "rgba(254,254,254,1)";
    cx.fillRect(16, 0, 1, 1);
    cx.fillRect(17, 0, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(0, 1, 1, 1);
    cx.fillRect(1, 1, 1, 1);
    cx.fillRect(2, 1, 1, 1);
    cx.fillRect(3, 1, 1, 1);
    cx.fillRect(4, 1, 1, 1);
    cx.fillRect(5, 1, 1, 1);
    cx.fillRect(6, 1, 1, 1);
    cx.fillRect(7, 1, 1, 1);
    cx.fillRect(8, 1, 1, 1);
    cx.fillRect(9, 1, 1, 1);
    cx.fillRect(10, 1, 1, 1);
    cx.fillRect(11, 1, 1, 1);
    cx.fillRect(12, 1, 1, 1);
    cx.fillRect(13, 1, 1, 1);
    cx.fillRect(14, 1, 1, 1);
    cx.fillRect(15, 1, 1, 1);
    cx.fillRect(16, 1, 1, 1);
    cx.fillRect(17, 1, 1, 1);
    cx.fillRect(0, 2, 1, 1);
    cx.fillRect(1, 2, 1, 1);
    cx.fillRect(2, 2, 1, 1);
    cx.fillRect(3, 2, 1, 1);
    cx.fillRect(4, 2, 1, 1);
    cx.fillRect(5, 2, 1, 1);
    cx.fillRect(6, 2, 1, 1);
    cx.fillRect(7, 2, 1, 1);
    cx.fillRect(8, 2, 1, 1);
    cx.fillRect(9, 2, 1, 1);
    cx.fillRect(10, 2, 1, 1);
    cx.fillRect(11, 2, 1, 1);
    cx.fillRect(12, 2, 1, 1);
    cx.fillRect(13, 2, 1, 1);
    cx.fillRect(14, 2, 1, 1);
    cx.fillRect(15, 2, 1, 1);
    cx.fillRect(16, 2, 1, 1);
    cx.fillRect(17, 2, 1, 1);
    cx.fillRect(0, 3, 1, 1);
    cx.fillRect(1, 3, 1, 1);
    cx.fillStyle = "rgba(247,247,247,1)";
    cx.fillRect(2, 3, 1, 1);
    cx.fillStyle = "rgba(211,211,211,1)";
    cx.fillRect(3, 3, 1, 1);
    cx.fillStyle = "rgba(213,213,213,1)";
    cx.fillRect(4, 3, 1, 1);
    cx.fillRect(5, 3, 1, 1);
    cx.fillStyle = "rgba(215,215,215,1)";
    cx.fillRect(6, 3, 1, 1);
    cx.fillRect(7, 3, 1, 1);
    cx.fillRect(8, 3, 1, 1);
    cx.fillStyle = "rgba(214,214,214,1)";
    cx.fillRect(9, 3, 1, 1);
    cx.fillRect(10, 3, 1, 1);
    cx.fillStyle = "rgba(215,215,215,1)";
    cx.fillRect(11, 3, 1, 1);
    cx.fillStyle = "rgba(217,217,217,1)";
    cx.fillRect(12, 3, 1, 1);
    cx.fillStyle = "rgba(214,214,214,1)";
    cx.fillRect(13, 3, 1, 1);
    cx.fillStyle = "rgba(211,211,211,1)";
    cx.fillRect(14, 3, 1, 1);
    cx.fillStyle = "rgba(232,232,232,1)";
    cx.fillRect(15, 3, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(16, 3, 1, 1);
    cx.fillRect(17, 3, 1, 1);
    cx.fillRect(0, 4, 1, 1);
    cx.fillRect(1, 4, 1, 1);
    cx.fillStyle = "rgba(17,17,17,1)";
    cx.fillRect(2, 4, 1, 1);
    cx.fillStyle = "rgba(10,10,10,1)";
    cx.fillRect(3, 4, 1, 1);
    cx.fillStyle = "rgba(13,13,13,1)";
    cx.fillRect(4, 4, 1, 1);
    cx.fillRect(5, 4, 1, 1);
    cx.fillRect(6, 4, 1, 1);
    cx.fillRect(7, 4, 1, 1);
    cx.fillRect(8, 4, 1, 1);
    cx.fillRect(9, 4, 1, 1);
    cx.fillRect(10, 4, 1, 1);
    cx.fillRect(11, 4, 1, 1);
    cx.fillStyle = "rgba(12,12,12,1)";
    cx.fillRect(12, 4, 1, 1);
    cx.fillStyle = "rgba(13,13,13,1)";
    cx.fillRect(13, 4, 1, 1);
    cx.fillStyle = "rgba(12,12,12,1)";
    cx.fillRect(14, 4, 1, 1);
    cx.fillStyle = "rgba(0,0,0,1)";
    cx.fillRect(15, 4, 1, 1);
    cx.fillStyle = "rgba(242,242,242,1)";
    cx.fillRect(16, 4, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(17, 4, 1, 1);
    cx.fillRect(0, 5, 1, 1);
    cx.fillRect(1, 5, 1, 1);
    cx.fillStyle = "rgba(19,19,19,1)";
    cx.fillRect(2, 5, 1, 1);
    cx.fillStyle = "rgba(32,32,32,1)";
    cx.fillRect(3, 5, 1, 1);
    cx.fillStyle = "rgba(34,34,34,1)";
    cx.fillRect(4, 5, 1, 1);
    cx.fillRect(5, 5, 1, 1);
    cx.fillRect(6, 5, 1, 1);
    cx.fillRect(7, 5, 1, 1);
    cx.fillRect(8, 5, 1, 1);
    cx.fillRect(9, 5, 1, 1);
    cx.fillRect(10, 5, 1, 1);
    cx.fillRect(11, 5, 1, 1);
    cx.fillRect(12, 5, 1, 1);
    cx.fillRect(13, 5, 1, 1);
    cx.fillRect(14, 5, 1, 1);
    cx.fillStyle = "rgba(10,10,10,1)";
    cx.fillRect(15, 5, 1, 1);
    cx.fillStyle = "rgba(231,231,231,1)";
    cx.fillRect(16, 5, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(17, 5, 1, 1);
    cx.fillRect(0, 6, 1, 1);
    cx.fillRect(1, 6, 1, 1);
    cx.fillStyle = "rgba(8,8,8,1)";
    cx.fillRect(2, 6, 1, 1);
    cx.fillStyle = "rgba(16,16,16,1)";
    cx.fillRect(3, 6, 1, 1);
    cx.fillStyle = "rgba(18,18,18,1)";
    cx.fillRect(4, 6, 1, 1);
    cx.fillRect(5, 6, 1, 1);
    cx.fillRect(6, 6, 1, 1);
    cx.fillStyle = "rgba(17,17,17,1)";
    cx.fillRect(7, 6, 1, 1);
    cx.fillStyle = "rgba(18,18,18,1)";
    cx.fillRect(8, 6, 1, 1);
    cx.fillRect(9, 6, 1, 1);
    cx.fillRect(10, 6, 1, 1);
    cx.fillRect(11, 6, 1, 1);
    cx.fillRect(12, 6, 1, 1);
    cx.fillRect(13, 6, 1, 1);
    cx.fillRect(14, 6, 1, 1);
    cx.fillStyle = "rgba(0,0,0,1)";
    cx.fillRect(15, 6, 1, 1);
    cx.fillStyle = "rgba(238,238,238,1)";
    cx.fillRect(16, 6, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(17, 6, 1, 1);
    cx.fillRect(0, 7, 1, 1);
    cx.fillRect(1, 7, 1, 1);
    cx.fillStyle = "rgba(210,210,210,1)";
    cx.fillRect(2, 7, 1, 1);
    cx.fillStyle = "rgba(159,159,159,1)";
    cx.fillRect(3, 7, 1, 1);
    cx.fillStyle = "rgba(165,165,165,1)";
    cx.fillRect(4, 7, 1, 1);
    cx.fillRect(5, 7, 1, 1);
    cx.fillRect(6, 7, 1, 1);
    cx.fillStyle = "rgba(166,166,166,1)";
    cx.fillRect(7, 7, 1, 1);
    cx.fillRect(8, 7, 1, 1);
    cx.fillStyle = "rgba(164,164,164,1)";
    cx.fillRect(9, 7, 1, 1);
    cx.fillStyle = "rgba(165,165,165,1)";
    cx.fillRect(10, 7, 1, 1);
    cx.fillRect(11, 7, 1, 1);
    cx.fillRect(12, 7, 1, 1);
    cx.fillRect(13, 7, 1, 1);
    cx.fillStyle = "rgba(162,162,162,1)";
    cx.fillRect(14, 7, 1, 1);
    cx.fillStyle = "rgba(183,183,183,1)";
    cx.fillRect(15, 7, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(16, 7, 1, 1);
    cx.fillRect(17, 7, 1, 1);
    cx.fillRect(0, 8, 1, 1);
    cx.fillRect(1, 8, 1, 1);
    cx.fillRect(2, 8, 1, 1);
    cx.fillRect(3, 8, 1, 1);
    cx.fillRect(4, 8, 1, 1);
    cx.fillRect(5, 8, 1, 1);
    cx.fillRect(6, 8, 1, 1);
    cx.fillRect(7, 8, 1, 1);
    cx.fillRect(8, 8, 1, 1);
    cx.fillRect(9, 8, 1, 1);
    cx.fillRect(10, 8, 1, 1);
    cx.fillRect(11, 8, 1, 1);
    cx.fillRect(12, 8, 1, 1);
    cx.fillRect(13, 8, 1, 1);
    cx.fillRect(14, 8, 1, 1);
    cx.fillRect(15, 8, 1, 1);
    cx.fillRect(16, 8, 1, 1);
    cx.fillStyle = "rgba(254,254,254,1)";
    cx.fillRect(17, 8, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(0, 9, 1, 1);
    cx.fillRect(1, 9, 1, 1);
    cx.fillRect(2, 9, 1, 1);
    cx.fillRect(3, 9, 1, 1);
    cx.fillRect(4, 9, 1, 1);
    cx.fillRect(5, 9, 1, 1);
    cx.fillRect(6, 9, 1, 1);
    cx.fillRect(7, 9, 1, 1);
    cx.fillRect(8, 9, 1, 1);
    cx.fillRect(9, 9, 1, 1);
    cx.fillRect(10, 9, 1, 1);
    cx.fillRect(11, 9, 1, 1);
    cx.fillRect(12, 9, 1, 1);
    cx.fillRect(13, 9, 1, 1);
    cx.fillRect(14, 9, 1, 1);
    cx.fillRect(15, 9, 1, 1);
    cx.fillRect(16, 9, 1, 1);
    cx.fillRect(17, 9, 1, 1);
    cx.fillRect(0, 10, 1, 1);
    cx.fillRect(1, 10, 1, 1);
    cx.fillRect(2, 10, 1, 1);
    cx.fillRect(3, 10, 1, 1);
    cx.fillRect(4, 10, 1, 1);
    cx.fillRect(5, 10, 1, 1);
    cx.fillRect(6, 10, 1, 1);
    cx.fillRect(7, 10, 1, 1);
    cx.fillRect(8, 10, 1, 1);
    cx.fillRect(9, 10, 1, 1);
    cx.fillRect(10, 10, 1, 1);
    cx.fillRect(11, 10, 1, 1);
    cx.fillRect(12, 10, 1, 1);
    cx.fillRect(13, 10, 1, 1);
    cx.fillRect(14, 10, 1, 1);
    cx.fillRect(15, 10, 1, 1);
    cx.fillRect(16, 10, 1, 1);
    cx.fillRect(17, 10, 1, 1);
    cx.fillStyle = "rgba(252,252,252,1)";
    cx.fillRect(0, 11, 1, 1);
    cx.fillStyle = "rgba(255,255,255,1)";
    cx.fillRect(1, 11, 1, 1);
    cx.fillRect(2, 11, 1, 1);
    cx.fillRect(3, 11, 1, 1);
    cx.fillRect(4, 11, 1, 1);
    cx.fillRect(5, 11, 1, 1);
    cx.fillRect(6, 11, 1, 1);
    cx.fillRect(7, 11, 1, 1);
    cx.fillRect(8, 11, 1, 1);
    cx.fillRect(9, 11, 1, 1);
    cx.fillRect(10, 11, 1, 1);
    cx.fillRect(11, 11, 1, 1);
    cx.fillRect(12, 11, 1, 1);
    cx.fillRect(13, 11, 1, 1);
    cx.fillRect(14, 11, 1, 1);
    cx.fillRect(15, 11, 1, 1);
    cx.fillRect(16, 11, 1, 1);
    cx.fillRect(17, 11, 1, 1);

    c.toDataURL();
};

export default minusImgCanvas;
